import { create } from 'zustand';

type Props = {
    remainingLimitMonth: {idr: number, usd: number};
    remainingLimitYear: {idr: number, usd: number};
    setRemainingLimitMonth: (remainingLimitMonth: {idr: number, usd: number}) => void;
    setRemainingLimitYear: (remainingLimitYear: {idr: number, usd: number}) => void;
}

export const useReimbursmentStore = create<Props>((set, getState) => ({
    remainingLimitMonth: {idr: 0, usd: 0},
    remainingLimitYear: {idr: 0, usd: 0},

    setRemainingLimitMonth: (remainingLimitMonth) => {
        set({ remainingLimitMonth });
    }, 

    setRemainingLimitYear: (remainingLimitYear) => {
        set({ remainingLimitYear });
    },
}));